import { FC, MouseEvent, useState } from 'react'

import { IBucketProduct } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'
import { QRMBucketSlice } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer'
import { useOpenProduct } from 'featureSliced/shared/hooks/openModals/useOpenProductModal'
import { ContextMenu } from 'components/ContextMenu'
import { Cart } from 'featureSliced/widgets/Cart'
import { RenderIf } from 'components/RenderIf'

import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'

import basket from 'assets/basket_small.svg'
import trashCan from 'assets/trashCan.svg'

import { IPosition } from './types'
import { BucketProductsContainer } from './styled'
import { ICartProduct } from 'featureSliced/shared/store/generalTypes'
import { useUpdateBucketProduct } from 'featureSliced/shared/hooks/openModals/useOpenProductModal/useUpdateBucketProduct'
import { getProductDiscount } from 'featureSliced/shared/utils/getProductDiscount'

export const BucketProducts: FC = () => {
  const t = useTranslations()
  const dispatch = useMyDispatch()
  const discounts = useMySelector((state) => state.specials?.discounts)

  const openBucketProductModal = useUpdateBucketProduct()
  const bucketProducts = useMySelector((state) => state.bucket.products)
  const [selectedProduct, setSelectedProduct] = useState<IBucketProduct>()

  const [position, setPosition] = useState<IPosition | null>(null)
  const removeProductFromBucket = QRMBucketSlice.actions.removeProductFromBucket

  const productsList = useMySelector((state) =>
    state.categories.items.flatMap((cat) => cat.products)
  )

  // Function
  const openProductModal = (product: IBucketProduct) => {
    const fullProduct = productsList?.find((p) => p.id === product.productId)
    fullProduct && openBucketProductModal(product)
  }

  const handleProductClick = (
    _productId: number,
    e: MouseEvent<HTMLElement>,
    product2: ICartProduct
  ) => {
    const product = bucketProducts?.find(
      (bP) => bP.uniqueId === product2.uniqueId
    )
    setSelectedProduct(product)
    setPosition({
      // x: e.pageX,
      x: e.pageX + 145 > window.innerWidth ? e.pageX - 125 : e.pageX,
      y: e.pageY,
    })
  }

  return (
    <BucketProductsContainer>
      <Cart
        products={bucketProducts?.map((el) => ({
          ...el,
          discountP: getProductDiscount(el, discounts),
        }))}
        handleProductClick={handleProductClick}
      />
      <RenderIf condition={!!position}>
        <ContextMenu
          position={position as IPosition}
          discardPosition={() => setPosition(null)}
          items={contextMenuItems(
            t,
            selectedProduct as IBucketProduct,
            openProductModal,
            (uniqueId: string) => dispatch(removeProductFromBucket(uniqueId))
            // !selectedProduct?.menuItems
          )}
        />
      </RenderIf>
    </BucketProductsContainer>
  )
}

// TODO: isn't DRY. Repeats in Overview.tsx
const contextMenuItems = (
  t: any,
  selectedProduct: IBucketProduct,
  handleEditClick: (product: IBucketProduct) => void,
  handleRemoveProduct: (id: string) => void
) => [
  {
    component: (
      <>
        <img src={basket} alt="Edit" />
        {t('buttons.edit')}
      </>
    ),
    onClick: () => handleEditClick(selectedProduct),
  },
  {
    component: (
      <>
        <img src={trashCan} alt="Remove" />
        {t('buttons.remove')}
      </>
    ),
    onClick: () => {
      handleRemoveProduct(selectedProduct.uniqueId as string)
    },
  },
]
